var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterBookIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_7748)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_7748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_7748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7566 3.0288C15.6587 1.56475 13.9354 0.703145 12.1053 0.703145H11.8944C10.0644 0.703145 8.34118 1.56475 7.24318 3.0288L7.243 3.02899C6.90878 3.47472 6.72803 4.01678 6.72803 4.57394V7.48122C6.72803 10.3929 9.08832 12.7531 11.9999 12.7531C14.9115 12.7531 17.2718 10.3929 17.2718 7.48122V4.57394C17.2718 4.01678 17.0911 3.47472 16.7568 3.02899L16.7566 3.0288Z",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72803 6.72809H6.72812C7.21028 6.72809 7.6727 6.53651 8.01367 6.19564C8.44707 5.76218 8.9874 5.22185 8.9874 5.22185H8.9875C10.8839 6.17009 13.116 6.17009 15.0123 5.22185H15.0124C15.0124 5.22185 15.5527 5.76218 15.9862 6.19564C16.3271 6.53651 16.7896 6.72809 17.2717 6.72809H17.2718",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 23.2969C23.2969 23.2969 22.3775 20.5388 21.7117 18.5414C21.2934 17.2866 20.2474 16.3432 18.9562 16.0562C16.9639 15.6135 14.2594 15.0125 14.2594 15.0125L12 18.7781L9.74062 15.0125C9.74062 15.0125 7.03613 15.6135 5.0438 16.0562C3.75258 16.3432 2.70656 17.2866 2.28825 18.5414C1.62248 20.5388 0.703125 23.2969 0.703125 23.2969",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74072 15.0125V12.3619",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2593 15.0125V12.3619",
    stroke: "#122733",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7658 23.2969H15.0127V21.0375C15.0127 20.4383 15.2507 19.8636 15.6745 19.4399C16.0982 19.0162 16.6729 18.7781 17.2721 18.7781C18.5199 18.7781 19.5314 19.7897 19.5314 21.0375V23.2969H18.7784",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.272 18.025V15.6819",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72791 20.2844C5.89659 20.2844 5.22168 20.9593 5.22168 21.7906C5.22168 22.6219 5.89659 23.2969 6.72791 23.2969C7.55924 23.2969 8.23415 22.6219 8.23415 21.7906C8.23415 20.9593 7.55924 20.2844 6.72791 20.2844Z",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72803 20.2844V15.6819",
    stroke: "#122733",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_7748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterBookIcon1);
export default __webpack_public_path__ + "static/media/afterBookIcon1.362b6c1a21c8e4bc14efbd28892484a6.svg";
export { ForwardRef as ReactComponent };